import {TranslationFunction} from "../../../../../store/localization/TranslMessasge";
import {RelationshipDirection} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";
import {StereotypesTranslationKey} from "../StereotypesTranslationKey";

export class ReferenceRelationshipDirectionFormatter {
    static formatDirection(direction: RelationshipDirection | string | undefined | null, t: TranslationFunction) {
        if (!direction) {
            return "";
        }
        return t(StereotypesTranslationKey.RELATIONSHIP_DIRECTION + "." + direction);
    }
}
